import { Component, createRef, useEffect } from 'react';


type Props = {
    htmlContent: string;
    classNames?: string;
    clearHTML?: boolean;
}

const LimitedContent: React.FC<Props> = (props) => {

    const contentElementRef = createRef<HTMLDivElement>();

    useEffect(() => { removeTabIndexOfHiddenContent() }, []);


    const removeTabIndexOfHiddenContent = () => {
        const contentElementRect = contentElementRef.current.getBoundingClientRect();
        const parentBottom = contentElementRect.bottom;

        contentElementRef.current.querySelectorAll("a").forEach(
            element => {
                const elementRect = element.getBoundingClientRect();
                const elementBottom = elementRect.bottom;


                if (elementBottom > parentBottom) {
                    element.tabIndex = -1;
                    element["data-invisible"] = "true";
                } 
            }
        );
    }

    const stripHtmlTags = (input: string) => {
        if (input == null) {
            return "";
        }
        const regex = /<.*?>/g;
        return input.replace(regex, '');
    }

    const getContent = () => {
        if (props.clearHTML) {
            return stripHtmlTags(props.htmlContent);
        }
        return props.htmlContent;
    }

    return <p ref={contentElementRef}
        className={"limited-content " + props.classNames}
        dangerouslySetInnerHTML={{ __html: getContent() }}>
    </p>

}

export default LimitedContent;